module.exports = __webpack_public_path__ + "img/40_38_078_250.e6ef89e7.jpg";